import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import { v4 as uuidv4 } from "uuid";
import { ModalBody } from "reactstrap";
import {
  MAX_FILE_SIZE,
  showFileSizeError,
} from "../../../../assests/extention/commonfunction";
import {
  validDocumentTypes,
  validImageTypes,
} from "../../../../assests/extention/fileextention";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";

export default function ModelFile({ formData, setFormData, setModalFile }) {
  const [selectedFiles, setSelectedFiles] = useState(
    formData.files?.map((file) => ({ ...file, status: file.status || 1 })) || []
  );

  const handleUpload = (files) => {
    const uploadPromises = files.map((file) => {
      const uniqueId = uuidv4();
      const fileRef = ref(getStorage(), `/Category/${uniqueId}_${file.name}`);
      const uploadTask = uploadBytesResumable(fileRef, file);

      return uploadTask
        .then(async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          return { file: url, name: file.name, type: file.type, status: 1 };
        })
        .catch((error) => {
          urtoast(`Upload failed: ${error.message}`);
          throw error;
        });
    });

    Promise.all(uploadPromises)
      .then((uploaded) => {
        const updatedFiles = [...selectedFiles, ...uploaded];
        setSelectedFiles(updatedFiles);
        urtoast("Files uploaded successfully!", 1);
      })
      .catch(() => { });
  };

  const onDrop = (acceptedFiles, fileRejections) => {
    if (fileRejections.length > 0) {
      showFileSizeError();
      return;
    }

    // ✅ Filter only allowed types
    const filteredFiles = acceptedFiles.filter((file) => {
      const fileType = file.type;
      const isValid =
        validImageTypes.includes(fileType) ||
        validDocumentTypes.includes(fileType);

      if (!isValid) {
        urtoast(`This file type is not supported`);
      }
      return isValid;
    });

    if (filteredFiles.length > 0) {
      handleUpload(filteredFiles);
    }
  };

  const handleDeleteImage = (index) => {
    if (formData.id) {
      const updatedFiles = selectedFiles.map((file, i) =>
        i === index ? { ...file, status: 3 } : file
      );
      setSelectedFiles(updatedFiles);
    } else {
      setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleSave = () => {
    setFormData((prevData) => ({
      ...prevData,
      files: selectedFiles,
    }));
    setModalFile((state) => !state);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxSize: MAX_FILE_SIZE,
    multiple: true,
  });

  return (
    <>
      <button
        onClick={() => setModalFile((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="close"
        />
      </button>

      <ModalBody>
        <div>
          <h4 className="skill-right file-attachment">Upload Documents</h4>

          <div className="row" style={{ rowGap: "10px" }}>
            {selectedFiles?.length === 0 ? (
              <div className="col-md-6 image-container">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
                  className="cover-img"
                  alt="Certificate"
                />
              </div>
            ) : (
              selectedFiles?.map(
                (item, index) =>
                  item.status !== 3 && (
                    <div key={index} className="col-md-4">
                      <div className="image-container">
                        <DisplayFileProper item={item} />
                        <button
                          type="button"
                          className="delete-button"
                          onClick={() => handleDeleteImage(index)}
                        >
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                            alt="delete"
                          />
                        </button>
                      </div>
                    </div>
                  )
              )
            )}
          </div>

          <div {...getRootProps({ className: "dropzone borderstylex" })}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drop the files here...</p>
            ) : (
              <label>
                Drag and drop or <span>Browse file</span>
              </label>
            )}
          </div>

          <ul className="border-ul">
            <li>Images (JPG, PNG, JPEG up to 10MB)</li>
            <li>Documents (PDF, DOCX, XLSX, PPTX, ZIP, TXT up to 10MB)</li>
          </ul>
        </div>
      </ModalBody>

      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
